// Static configuration for the Monitoring maps: camera fallback and the
// toolbar toggle tables. The basemap tiles are shared app-wide — see
// `utils/leaflet`.

// Fallback view when no active drivers have lat/lng yet — Chicago metro area
// since the fixture set is Chicago-based. Real prod will derive this from
// the selected market's depot location.
export const FALLBACK_CENTER = [41.8781, -87.6298];
export const FALLBACK_ZOOM = 11;

// AM/PM/All toggle options for the map toolbar. 'all' = no shift filter.
export const SHIFT_FILTERS = [
  { value: 'all', label: 'All', title: 'Show all routes' },
  { value: 'am', label: 'AM', title: 'Show only AM routes' },
  { value: 'pm', label: 'PM', title: 'Show only PM routes' },
];

// List / Map switch for the Monitoring tab (rendered by MonitoringFilterBar).
export const VIEW_OPTIONS = [
  { value: 'list', label: 'List' },
  { value: 'map', label: 'Map' },
];
